import { createContext, useContext } from 'react';

/**
 * Meta Ads del espacio activo para las fichas (E4). Lo provee MapPage solo con
 * el flag prendido y la API respondiendo (`getmetaconnection` sin 404 / 403);
 * fuera de MapPage (shares públicos, páginas compartidas) no hay provider y la
 * sección «Campañas» no existe.
 *
 * Valor: `{ metaConnection, openPanel(view?: 'campaigns', options?: { campaignId }), viewerUserId, openRecordTarget(target),
 *   campaignsVersion, invalidateCampaigns() }`. F2a: `invalidateCampaigns` (después de una acción en Meta)
 * sube `campaignsVersion` y las fichas abiertas vuelven a pedir su sección «Campañas».
 * `openPanel('campaigns', { campaignId })` abre Campañas con esa campaña elegida en el buscador.
 * `openRecordTarget`: abre la ficha de una unidad vinculada (chips de Campañas); recibe el
 * mismo destino que los intereses de un lead (`useLeadItemOpener` → `handleOpenLeadItemTarget`).
 */
const MetaAdsContext = createContext(null);

export const MetaAdsProvider = MetaAdsContext.Provider;

export const useMetaAdsContext = () => useContext(MetaAdsContext);
